import React from 'react';
import { motion } from 'framer-motion';
import ScrollReveal from '../premium/ScrollReveal';
import './HomeProductShowcase.css';

const HomeProductShowcase: React.FC = () => {
    return (
        <section className="home-product-showcase full-bleed">
            <div className="container container--edge">
                <ScrollReveal className="lummo-header">
                    <span className="lummo-eyebrow">Designed for clinical research in LATAM</span>
                    <h2 className="lummo-title">
                        All-in-one <span className="lummo-title-accent">Agent-Native</span> Infrastructure
                    </h2>
                    <p className="lummo-subtitle">
                        From protocol design to patient engagement, our AI platform streamlines operations, reduces setup work and keeps
                        compliance aligned with local regulations.
                    </p>
                </ScrollReveal>

                <div className="lummo-cards-grid">
                    <motion.article
                        className="lummo-card"
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        whileHover={{ y: -6 }}
                        viewport={{ once: true, margin: '-40px' }}
                        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <div className="lummo-card-media">
                            <img src="/images/cro.png" alt="CROs" />
                        </div>
                        <div className="lummo-card-body">
                            <h3 className="lummo-card-title">CROs</h3>
                            <p className="lummo-card-desc">Faster study kick-off, automated operations and unified reporting.</p>
                            <ul className="lummo-card-list">
                                <li>Automated startup &amp; feasibility</li>
                                <li>Protocol &amp; site package generation</li>
                                <li>Regulatory tracking dashboard</li>
                            </ul>
                            <div className="lummo-card-badges">
                                <span className="lummo-badge">Automation</span>
                                <span className="lummo-badge">Ops</span>
                                <span className="lummo-badge">Compliance</span>
                            </div>
                            <a href="/solution/cros" className="lummo-cta">Explore CROs →</a>
                        </div>
                    </motion.article>

                    <motion.article
                        className="lummo-card"
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        whileHover={{ y: -6 }}
                        viewport={{ once: true, margin: '-40px' }}
                        transition={{ delay: 0.08, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <div className="lummo-card-media">
                            <img src="/images/sites.png" alt="Sites" />
                        </div>
                        <div className="lummo-card-body">
                            <h3 className="lummo-card-title">Sites</h3>
                            <p className="lummo-card-desc">Less admin. Clean docs. Clear tasks for coordinators and PIs.</p>
                            <ul className="lummo-card-list">
                                <li>Document control &amp; templates</li>
                                <li>eISF &amp; task automation</li>
                                <li>One place for approvals</li>
                            </ul>
                            <div className="lummo-card-badges">
                                <span className="lummo-badge">Docs</span>
                                <span className="lummo-badge">eISF</span>
                                <span className="lummo-badge">Ops</span>
                            </div>
                            <a href="/solution/sites" className="lummo-cta">Explore Sites →</a>
                        </div>
                    </motion.article>

                    <motion.article
                        className="lummo-card"
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        whileHover={{ y: -6 }}
                        viewport={{ once: true, margin: '-40px' }}
                        transition={{ delay: 0.16, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <div className="lummo-card-media">
                            <img src="/images/patients.png" alt="Patients" />
                        </div>
                        <div className="lummo-card-body">
                            <h3 className="lummo-card-title">Patients</h3>
                            <p className="lummo-card-desc">Friendly onboarding, eConsent and reminders that actually get answered.</p>
                            <ul className="lummo-card-list">
                                <li>Voice &amp; chat onboarding</li>
                                <li>eConsent &amp; follow-ups</li>
                                <li>Engagement analytics</li>
                            </ul>
                            <div className="lummo-card-badges">
                                <span className="lummo-badge">eConsent</span>
                                <span className="lummo-badge">Engagement</span>
                            </div>
                            <a href="/solution/patients" className="lummo-cta">Explore Patients →</a>
                        </div>
                    </motion.article>
                </div>
            </div>
        </section>
    );
};

export default HomeProductShowcase;

